/* global Office */

Office.onReady(() => {});

// VOLITELNE: event-based handler pri odeslani/uprave schuzky organizatorem.
// Aktivuje se jen kdyz v manifestu odkomentujes <LaunchEvent OnAppointmentSend>.
// Necha backend pregenerovat pristupove okno podle aktualniho stavu schuzky.
// Pozn.: zruseni schuzky tudy nejde spolehlive zachytit -> resi Graph webhook na backendu.
async function onAppointmentSendHandler(event) {
  try {
    const item = Office.context.mailbox.item;
    const organizer = Office.context.mailbox.userProfile.emailAddress;
    await fetch("https://qrcal1.qrentry.app/api/issue-qr", {
      method: "POST",
      headers: {
        "X-Addin-Key": "472ab223-79e4-4070-b877-9f97344baed5081eb1f9154e48b69971cf52a7ec0380",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ iCalUid: item.iCalUid, organizer }),
    });
  } catch (e) {
    // Neblokuj odeslani schuzky kvuli chybe add-inu.
    console.error(e);
  }
  event.completed({ allowEvent: true });
}

// Registrace pro event-based aktivaci.
if (Office.actions && Office.actions.associate) {
  Office.actions.associate("onAppointmentSendHandler", onAppointmentSendHandler);
}
